if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt){
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        const giftCheckbox = this.querySelector('.js-pdp-gift-checkbox');

if (giftCheckbox?.checked && giftCheckbox.value) {
  try {
    const giftResponse = await fetch(routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(giftCheckbox.value),
            quantity: 1,
          },
        ],
      }),
    });

    const giftResult = await giftResponse.json();
    console.log('Gift variant ID:', giftCheckbox.value);
console.log('Gift response status:', giftResponse.status);
console.log('Gift response:', giftResult);

    if (!giftResponse.ok || giftResult.status) {
      this.handleErrorMessage(
        giftResult.description ||
          giftResult.message ||
          'Gift product could not be added.'
      );

      this.submitButton.classList.remove('loading');
      this.submitButton.removeAttribute('aria-disabled');

      const spinner = this.querySelector('.loading__spinner');

      if (spinner) {
        spinner.classList.add('hidden');
      }

      return;
    }
  } catch (error) {
    console.error('Gift product error:', error);

    this.handleErrorMessage(
      'Gift product could not be added. Please try again.'
    );

    this.submitButton.classList.remove('loading');
    this.submitButton.removeAttribute('aria-disabled');

    const spinner = this.querySelector('.loading__spinner');

    if (spinner) {
      spinner.classList.add('hidden');
    }

    return;
  }
}

// const giftCheckbox = this.querySelector('.js-pdp-gift-checkbox');

// if (giftCheckbox?.checked && giftCheckbox.value) {
//   try {
//     const giftVariantId = Number(giftCheckbox.value);

//     const cartResponse = await fetch(
//       `${window.Shopify.routes.root}cart.js`,
//       {
//         headers: {
//           Accept: 'application/json',
//           'X-Requested-With': 'XMLHttpRequest',
//         },
//       }
//     );

//     if (!cartResponse.ok) {
//       throw new Error('Cart could not be checked.');
//     }

//     const currentCart = await cartResponse.json();

//     const giftAlreadyInCart = currentCart.items.some(
//       (item) => item.variant_id === giftVariantId
//     );

//     if (!giftAlreadyInCart) {
//       const giftResponse = await fetch(routes.cart_add_url, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           Accept: 'application/json',
//           'X-Requested-With': 'XMLHttpRequest',
//         },
//         body: JSON.stringify({
//           items: [
//             {
//               id: giftVariantId,
//               quantity: 1,
//             },
//           ],
//         }),
//       });

//       const giftResult = await giftResponse.json();

//       if (!giftResponse.ok || giftResult.status) {
//         this.handleErrorMessage(
//           giftResult.description ||
//             giftResult.message ||
//             'Gift product could not be added.'
//         );

//         this.submitButton.classList.remove('loading');
//         this.submitButton.removeAttribute('aria-disabled');

//         const spinner = this.querySelector('.loading__spinner');

//         if (spinner) {
//           spinner.classList.add('hidden');
//         }

//         return;
//       }
//     }
//   } catch (error) {
//     console.error('Gift product error:', error);

//     this.handleErrorMessage(
//       error.message ||
//         'Gift product could not be added. Please try again.'
//     );

//     this.submitButton.classList.remove('loading');
//     this.submitButton.removeAttribute('aria-disabled');

//     const spinner = this.querySelector('.loading__spinner');

//     if (spinner) {
//       spinner.classList.add('hidden');
//     }

//     return;
//   }
// }

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
